import { render, staticRenderFns } from "./SectionHeadline.vue?vue&type=template&id=33076c53&scoped=true&"
import script from "./SectionHeadline.vue?vue&type=script&lang=js&"
export * from "./SectionHeadline.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeadline.vue?vue&type=style&index=0&id=33076c53&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33076c53",
  null
  
)

export default component.exports